import React from 'react';
import styles from './categoryCardFooter.module.scss';
import BudgetAmount from 'src/components/atomic/molecules/budgetAmount/BudgetAmount';
import ShowSubcategoryButton from 'src/components/atomic/molecules/showSubcategoryButton/ShowSubcategoryButton';
import SpentRemaining from 'src/components/atomic/molecules/spentRemaining/SpentRemaining';

interface CategoryCardFooterProps {
    budgetAmount?: number;
    spentAmount?: number;
    groupId?: string;
    isMinWidthSmall?: boolean;
    hasSubcategories?: boolean;
    showingSubcategories?: boolean;
    handleShowSubcategories?: () => void;
}

export default function CategoryCardFooter({
    budgetAmount,
    spentAmount,
    groupId,
    isMinWidthSmall,
    hasSubcategories,
    showingSubcategories,
    handleShowSubcategories
}: CategoryCardFooterProps): JSX.Element {
    const hasBudget: boolean = !!budgetAmount;

    const subcategoryButton: JSX.Element = (
        <ShowSubcategoryButton
            showingSubcategories={showingSubcategories}
            onClick={handleShowSubcategories}
            aria-expanded={showingSubcategories}
            aria-controls={`category-card-subcategories-${groupId}`}
            id={`category-card-show-subcategories-button-${groupId}`}
        />
    );

    if (!hasBudget && !hasSubcategories) return null;

    return (
        <div className={styles.footer}>
            <div className={styles.top}>
                <div>
                    {!isMinWidthSmall && hasBudget && <BudgetAmount amount={budgetAmount} />}
                    {((hasBudget && isMinWidthSmall) || !hasBudget) && hasSubcategories && subcategoryButton}
                </div>
                <div>
                    {hasBudget && (
                        <SpentRemaining
                            spentAmount={spentAmount}
                            budgetAmount={budgetAmount}
                            isMinWidthSmall={isMinWidthSmall}
                        />
                    )}
                </div>
            </div>
            <div className={styles.bottom}>
                {!isMinWidthSmall && hasBudget && hasSubcategories && subcategoryButton}
            </div>
        </div>
    );
}
